export default __webpack_public_path__ + "static/media/127_jellysterry.aeb058d5.png";